// extracted by mini-css-extract-plugin
module.exports = {"tag-list-component":"TagList_tag-list-component__8MPH_"};